import { Project } from "@/data/classes/project.class";
import { Image } from "@/components/blocks/image/image.class";

export class School {

	// Settings
	title;
	id;
	slug;

	// Content
	address;
	interlocutor;
	referenceText

	// Relations
	relatedProjects;


	constructor(object) {
		// console.log("💍 School:", object )

		// Settings
		this.title = object.title.rendered || null;
		this.id = object.id || null;
		this.slug = object.slug || null;
		
		// Content
		this.address = object.meta_box.school_content.address || null;
		this.interlocutor = object.meta_box.school_content.interlocutor || null;
		this.referenceText = object.meta_box.school_content.reference_text || null;
		this.referenceTextEng = object.meta_box.school_content.reference_text_eng || null;
		
		this.logos = [];
		// Logo
		if (object.related_ids && object.meta_box.school_content.logo ){
			this.logos = object.meta_box.school_content.logo.map(logo => {
				console.log("Logo: ", logo, "Related Ids: ", object.related_ids);
				if (object.related_ids[logo])
					return new Image(object.related_ids[logo]);
			})
		}

		this.projects = [];

		// Relations
		if (object.meta_box.school_to_project_to.length && object.related_ids) {
			this.projects = object.meta_box.school_to_project_to.map( project => {
				if (object.related_ids[project]){
					let projectContent = new Project( object.related_ids[project])
					return projectContent;
				}
			});
		}
	}
}

export class SchoolApplication {

	// Settings
	title;

	// Content
	address;
	interlocutor;
	referenceText;
	referenceTextEng;


	constructor(object) {
		// Settings
		this.title = object.title || null;

		this.meta_box = {
			school_content: {

			},
		};
		
		// Content
		this.meta_box.school_content.address = object.address || null;
		this.meta_box.school_content.interlocutor = object.interlocutor || null;
		this.meta_box.school_content.reference_text = object.referenceText || null;
		this.meta_box.school_content.reference_text_eng = object.referenceTextEng || null;

		// Relations
		if (object.projects && object.projects.length) {
			this.meta_box.school_to_project_to = object.projects.map(project => {
				return project.id;
			})
		} else {
			this.meta_box.school_to_project_to = [];
		}
		
		// logo
		if (object.logos) {
			this.meta_box.school_content.logo = object.logos.map(logo => {
				return logo.id;
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/school.class.js